<template>
  <b-modal
    :visible="visible"
    centered
    hide-footer
    no-close-on-backdrop
    dialog-class="desempenho-modal-dialog"
    content-class="desempenho-modal-content"
    body-class="desempenho-modal-body"
    @hide="$emit('close')"
  >
    <template #modal-header="{ close }">
      <div class="desempenho-modal-header">
        <h5 class="desempenho-modal-title">Desempenho</h5>
        <div class="desempenho-modal-header-actions">
          <button
            type="button"
            class="desempenho-nova-aba-link"
            :disabled="!municipio"
            title="Abrir em nova guia"
            @click="abrirEditorCartaz"
          >
            <i class="icofont-external-link" aria-hidden="true"></i>
            <span class="desempenho-nova-aba-label">Abrir em nova guia</span>
          </button>
          <button
            type="button"
            class="close desempenho-modal-close"
            aria-label="Fechar"
            @click="close()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </template>

    <CartazPreview
      v-if="visible && municipio"
      :dados="dadosCartaz"
      embedded
    />
  </b-modal>
</template>

<script>
import CartazPreview from '@/pages/Cofinanciamento/DesempenhoCartaz/CartazPreview.vue'
import { montarQueryCartaz } from '@/pages/Cofinanciamento/DesempenhoCartaz/queryMapper.js'

export default {
  name: 'ModalDesempenho',

  components: {
    CartazPreview,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    municipio: {
      type: Object,
      default: null,
    },
    page: {
      type: String,
      default: '',
    },
    regiao: {
      type: String,
      default: '',
    },
  },

  computed: {
    dadosCartaz() {
      return montarQueryCartaz(this.municipio, {
        page: this.page,
        regiao: this.regiao,
      })
    },
  },

  methods: {
    abrirEditorCartaz() {
      if (!this.municipio) return

      const rota = this.$router.resolve({
        path: '/cofinanciamento/desempenho-cartaz',
        query: this.dadosCartaz,
      })

      window.open(rota.href, '_blank')
    },
  },
}
</script>

<style lang="scss">
.desempenho-modal-content > .modal-header {
  flex-shrink: 0;
  padding: 12px 16px;
}

.desempenho-modal-header {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  min-height: 36px;
  gap: 10px;
}

.desempenho-modal-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  text-transform: uppercase;
  text-align: left;
  flex: 1 1 auto;
  min-width: 0;
}

.desempenho-modal-header-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1;
  flex-shrink: 0;
}

.desempenho-nova-aba-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  margin: 0;
  border: 0;
  background: transparent;
  color: #6c757d;
  font-size: 0.875rem;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: none;

  &:hover,
  &:focus {
    color: #495057;
    text-decoration: underline;
    outline: none;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    text-decoration: none;
  }
}

.desempenho-modal-close {
  padding: 0 4px;
  margin: 0;
  line-height: 1;
}

.modal-dialog.desempenho-modal-dialog {
  max-width: min(90vw, 920px) !important;
  width: min(90vw, 920px) !important;
  margin: 1.5vh auto !important;
  height: 95vh;
}

.desempenho-modal-content {
  height: 95vh;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
}

.desempenho-modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 8px 10px 10px !important;
}

@media (max-width: 768px) {
  .modal-dialog.desempenho-modal-dialog {
    max-width: 100vw !important;
    width: 100vw !important;
    margin: 0 !important;
    height: 100vh;
  }

  .desempenho-modal-content {
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }

  .desempenho-modal-content > .modal-header {
    padding: 10px 12px;
  }

  .desempenho-modal-header {
    gap: 8px;
  }

  .desempenho-modal-title {
    font-size: 1.05rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .desempenho-nova-aba-label {
    display: none;
  }

  .desempenho-modal-close {
    font-size: 1.6rem;
    width: 36px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
